<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <src-create-or-update v-model="src" :errors="errors"></src-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SRCCreateOrUpdate from './components/SRCCreateOrUpdate.vue'
import SRCApi from '@/api/src-o'

export default {
    components:{
        BCard,
        'src-create-or-update':SRCCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"İsim",key:"Name", thClass:"w-100",sortable:true},   
                {name:"Yenileme Süresi (Yıl)",key:"ValidityYear",sortable:true},   
                {name:"Yenileme Süresi (Yıl) Var",key:"IsHasValidityYear",sortable:true},   
                {name:"Dosya Gerekli",key:"FileRequired",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            src:{
                Id:null,
                Name:null,
                IsHasValidityYear: false,
                ValidityYear: null,
                FileRequired: false
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.src.Id = null
            this.src.Name = null
            this.src.IsHasValidityYear = false
            this.src.ValidityYear = null
            this.src.FileRequired = false
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return SRCApi.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.src.Id = item.Id
            this.src.Name = item.Name
            this.src.IsHasValidityYear = item.IsHasValidityYear
            this.src.ValidityYear = item.ValidityYear
            this.src.FileRequired = item.FileRequired
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            const data = structuredClone(this.src)
            data.IsHasValidityYear == false ? data.ValidityYear = null : null
            SRCApi.CreateOrUpdate(this.editing,data).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli SRC belge türünü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    SRCApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>